import React from "react";
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import {StyledButton} from './button.style';
export interface IStyledButtonProps{
  disabled?: boolean,
  label: any,
  onClick?: (e?: any) => void,
  style?: any,
  startIcon?: any,
  endIcon?: any,
  loading?: any,
  variant?: any
  fullWidth?: any;
  className?: string;
  id?: string;
  [key: string]: any;
};
const HlxButton: React.FC<IStyledButtonProps> = (props):JSX.Element => {
  const { disabled, label, fullWidth, onClick, style, startIcon, endIcon, loading, variant, className, id, ...rest } = props;
  const buttonVariant = variant ?? (label.toUpperCase() === "CANCEL" || label.toUpperCase() === "LEAVE" ? "outlined" : "contained");

  return (
    <StyledButton className={`hlx-btn ${className}`} fullWidth={fullWidth}>
      <Button
        id={id}
        tabIndex={0}
        variant={buttonVariant}
        disabled={disabled || loading}
        fullWidth={fullWidth}
        onClick={onClick}
        style={{...style}}
        startIcon={loading && !!startIcon ? <CircularProgress size={16} /> : startIcon}
        endIcon={loading ? <CircularProgress size={16} /> : label.toUpperCase() !== 'SUBMIT' ? endIcon : undefined}
        {...rest}
      >
        {label}
      </Button>
    </StyledButton>

  );
};

export const defaultProps = {
  disabled: false,
  label: "Button",
  fullWidth: false,
  style: {},
  startIcon: '',
  endIcon: '',
  isUpperCase: true,
  loading: false,
  className: '',
};
HlxButton.defaultProps = defaultProps;

export default HlxButton;
